import styled from "styled-components";
import { StatCell, Stat } from "../styles";

export const PositionCell = styled(StatCell)<{
  accentColor?: string;
}>`
  ${({ accentColor }) =>
    accentColor && `border-left: 5px solid ${accentColor}; `}
`;

export const Position = styled(Stat)<{ hasAccent: boolean }>`
  padding-left: 5px;
  ${({ hasAccent }) => hasAccent && `margin-left: -5px;`}
`;
